import { TableHead } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SelectionTableHead = styled(TableHead)({
  "& th": {
    color: "text.secondary",
    textTransform: "uppercase",
    fontSize: "0.625rem",
    fontWeight: "500",
    lineHeight: "0.75rem",
    paddingTop: "0",
    paddingBottom: "0.9375rem",
    border: "none",
  },
});

export default SelectionTableHead;
